import { ChangeEvent, useEffect } from 'react';
import { Form } from "../system/useForm";
import { TextField, TextFieldProps } from "@mui/material";

type Props = TextFieldProps & {
	name: string
	form: Form
	required?: boolean
	email?: boolean
	maxLength?: number
	displayCharLimit?: boolean
}

const FormTextField = (props: Props) => {
	useEffect(() => {
		props.form.register(props.name, {
			required: props.required ?? false,
			email: props.email ?? false
		});

		return () => {
			props.form.unregister(props.name);
		};
	}, [props.name]);

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		const el = (event.target as HTMLInputElement);

		props.form.setValue(el.name, el.value);
	};

	const variant = props.variant ?? 'standard';

	const currentValue = props.form.getValue(props.name) ?? props.defaultValue ?? '';
	const error = props.form.errors[props.name];

	return (
		<TextField
			value={currentValue}
			fullWidth={props.fullWidth ?? false}
			error={!!error}
			name={props.name}
			disabled={props.disabled ?? false}
			label={props.label}
			onChange={handleChange}
			variant={variant}
			inputProps={props.maxLength ? { maxLength: props.maxLength } : undefined}
			helperText={
				!!error && error.message ? error.message : (props.displayCharLimit === true && (props.maxLength ? `${currentValue.length} / ${props.maxLength} Zeichen` : null))
			}
		/>
	);
};

export default FormTextField;
